module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-10 col-xs-offset-1"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paramsLocal),
      expression: "paramsLocal"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.paramsLocal = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.field.options), function(option) {
    return _c('option', {
      domProps: {
        "value": _vm.getValue(option)
      }
    }, [_vm._v(_vm._s(_vm.getLabel(option)))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d63604e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/subforms/SearchSelect.vue
// module id = 1083
// module chunks = 0